import React, { useState } from 'react';
import './index.css';
import GradientInput from 'common/components/GradientInput';
import Checkbox from 'common/components/Checkbox';
import { useTheme } from '@emotion/react';
import styled from '@emotion/styled';
import Button from 'common/components/Button';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import sendFetch from 'common/utils/fetch';
import { useAuth } from 'common/context/AuthContext';

const StyledForgotLink = styled.a`
    color: ${(props) => props.theme.colors.primaryColor};
    cursor: pointer;
    font-family: Mulish;
    font-size: 12px;
    &:hover {
        text-decoration: underline;
    }
`;

const SeparatorOr = () => {
  const theme = useTheme();
  return (
    <div className='login-separator-wrapper'>
      <div style={{ backgroundColor: theme.colors.gray }} className='login-separator-line'></div>
      <span style={{ color: theme.colors.gray }} className='se login-separator-text'>або</span>
      <div style={{ backgroundColor: theme.colors.gray }} className='login-separator-line'></div>
    </div>
  );
};

type MyLoginResponseProps = {
  token: string;
  ownerId: number;
};

type ResponseProps = [number, MyLoginResponseProps];

export default function LoginPage() {
  const location = useLocation();
  const navigate = useNavigate();
  const from = location.state?.from || null;
  console.log(from);
  const { updateToken, updateCompanyId } = useAuth();
  const [emailValue, setEmailValue] = useState('');
  const [passwordValue, setPasswordValue] = useState('');
  const [rememberCheck, setRememberCheck] = useState(false);
  const [emailError, setEmailError] = useState<boolean | string>(false);
  const [passwordError, setPasswordError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const checkEmail = (target:string = emailValue) => {
    const regExp = new RegExp(
      /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w\w+)+$/,
    );
    if (regExp.test(target)) {
      setEmailError(false);
      return true;
    } else {
      setEmailError(true);
      return false;
    }
  };
  const checkPassword = (target:string = passwordValue) => {
    if (target.length >= 8) {
      setPasswordError(false);
      return true;
    } else {
      setPasswordError(true);
      return false;
    }
  };
  const handleEmailChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (emailError) checkEmail(e.target.value);
    setEmailValue(e.target.value);
  };
  const handlePasswordChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if ( passwordError ) checkPassword(e.target.value);
    setPasswordValue(e.target.value);
  };
  const handleCheckChange = () => {
    setRememberCheck(!rememberCheck);
  };
  const fetchLogin = async () => {
    const formData = new FormData();
    formData.append('email', emailValue);
    formData.append('password', passwordValue);
    formData.append('rememberMe', rememberCheck ? 'true' : 'false');
    const response:ResponseProps = await sendFetch('/user/authorization', {
      method: 'POST',
      data: formData,
    }, true);
    setIsLoading(false);
    if (response[0] === 200 && response[1]?.token) {
      updateToken(response[1].token);
      navigate('/registration', { state: { ownerId: response[1]?.ownerId } });
    } else {
      setEmailError('Невірний логін або пароль');
      setPasswordError(true);
    }
  };

  const fetchLoginLocal = async () => {
    const formData = new FormData();
    formData.append('email', emailValue);
    formData.append('password', passwordValue);
    formData.append('rememberMe', rememberCheck ? 'true' : 'false');
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const response:any = await sendFetch('https://api-workspace.astin.net/api/user/local-auth', {
      method: 'POST',
      data: formData,
    });  
    console.log(response);
    if (response[0] === 200 && response[1]?.token) {
      if (response[1].ownCompany && response[1].myId) {
        updateToken(response[1].token);
        updateCompanyId(response[1].ownCompany);
      } else if (response[1].localId && response[1].workInCompany) {
        updateToken(response[1].token);
        updateCompanyId(response[1].workInCompany);
      } else {
        setEmailError('Невірний логін або пароль');
        setPasswordError(true);
        setIsLoading(false);
        return;
      }
      console.log('from', from);
      console.log('ownCompany', response[1].ownCompany);
      console.log('workInCompany', response[1].workInCompany);
      if (from) {
        navigate(from);
      } else {
        console.log(`/${response[1].ownCompany}`);
        navigate(`/${response[1].ownCompany}` || `/${response[1].workInCompany}` || '/contacts');
      }
      setIsLoading(false);
    } else {
      setEmailError('Невірний логін або пароль');
      setPasswordError(true);
      setIsLoading(false);
    }
  };

  const handleFormSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setIsLoading(true);
    const passwordCheck = checkPassword();
    const emailCheck = checkEmail();
    if (emailCheck && passwordCheck) {
      if (from === '/registration') {
        await fetchLogin();
      } else {
        await fetchLoginLocal();
      }
    } else {
      setIsLoading(false);
    }
  };
  const theme = useTheme();
  return (
    <section className='login-section'>
      <div className='login-background'></div>
      <form onSubmit={handleFormSubmit} className='login-wrapper'>
        <h3 className='login-title'>Вхід</h3>
        <span className='login-sub-title'>Використайте акаунт <span className='logo-text login-logo'>ASTIN</span></span>
        <GradientInput error={emailError} onChange={handleEmailChange} props={{ autoComplete:'email' }} placeholder='Корпоративна Е-пошта' value={emailValue} />
        {typeof(emailError) === 'string' && <span className='se error-text login-error'>{emailError}</span>}
        <GradientInput error={passwordError} password onChange={handlePasswordChange} props={{ autoComplete:'current-password' }} placeholder='Пароль' value={passwordValue} />
        <div className='login-check-wrapper'>
          <Checkbox size={18} checked={rememberCheck} onChange={handleCheckChange}>
            {'Запам’ятати пароль'}
          </Checkbox>
          <StyledForgotLink theme={theme}>Забули пароль?</StyledForgotLink>
        </div>
        <Button loading={isLoading} type='submit' className='login-button' primary label='УВІЙТИ' />
        <span className='se login-text'>Зареєструвавшись, ви погоджуєтеся з <Link className='basic-link' to='/terms_of_use'>Умовами користування</Link> та <Link className='basic-link' to='/privacy_policy'>Політикою Конфеденційності</Link></span>
        <SeparatorOr />
        <span style={{ display:'none' }} className='se login-text'>Працюєте на чужому комп’ютері? Увімкніть <a className='basic-link' rel='noreferrer' target='_blank' href='/'>гостьовий режим.</a></span>
        <a href='https://my.astin.io/registration/' rel='noreferrer' target='_blank' className='basic-link'>Створити профіль</a>

      </form>
    </section>
  );
}